import { getStore } from 'core_main/store';
import { importAndInitializePubNub } from 'core_main/globals/vendors';
import { handleError } from 'globals/errors';
import {
  CUSTOMER_TYPING_ENDED,
  CUSTOMER_TYPING,
} from 'core_main/pubnub/constants';
import { SendTypingActivityParameters } from './types';
import { validateSendTypingActivityParams } from './helpers';

export const sendTypingStatusSignal = (
  sessionId: SendTypingActivityParameters['conversationId'],
  typing: SendTypingActivityParameters['typing'],
) => {
  return importAndInitializePubNub().then((module) => {
    const pubnub = module;

    const store = getStore();

    const { sessions } = store;

    const session = sessions[sessionId];

    if (!session) return;

    const { channels } = session.attributes.pubnub.data;

    const sharedConversationChannel = channels.find(
      (channel) => channel.type === 'shared-conversation',
    );

    if (!sharedConversationChannel) return;

    const sharedConversationChannelName = sharedConversationChannel.name;

    const signalStatus = typing ? CUSTOMER_TYPING : CUSTOMER_TYPING_ENDED;

    if (store.isPubNubConnected) {
      pubnub.getMetaPubNub()?.instance?.signal({
        channel: sharedConversationChannelName,
        message: signalStatus,
      });
    }
  });
};

export const sendTypingActivity = (
  parameters: SendTypingActivityParameters,
) => {
  const sessionId = parameters?.conversationId;
  const typing = parameters?.typing;

  try {
    const validateSendTypingStatusParamsError =
      validateSendTypingActivityParams(sessionId, typing);

    if (validateSendTypingStatusParamsError) {
      throw validateSendTypingStatusParamsError;
    }

    const store = getStore();

    const { settings, sessions } = store;

    const { showTypingIndicatorWeb } = settings;

    if (!showTypingIndicatorWeb || !sessions[sessionId]) return undefined;

    return sendTypingStatusSignal(sessionId, typing);
  } catch (error) {
    handleError(error, {
      message: 'Failed to send typing status',
    });
  }

  return undefined;
};
